// Search configuration — actual values come from CDN (listing-search.json asset)
// These are fallback defaults if CDN is unavailable.

// Main search type: 'keywords' (not 'location' — no maps used)
export const mainSearch = {
  searchType: 'keywords',
};

export const listingTypeFilter = {
  enabled: true,
  schemaType: 'listingType',
};

export const categoryFilter = {
  enabled: true,
  schemaType: 'category',
};

export const dateRangeFilter = {
  enabled: false,
  schemaType: 'dates',
  dateRangeMode: 'day',
  availability: 'time-full',
};

export const priceFilter = {
  schemaType: 'price',
  min: 10,
  max: 5000,
  step: 5,
};

export const sortConfig = {
  active: true,
  queryParamName: 'sort',
  relevanceKey: 'relevance',
  relevanceFilter: 'keywords',
  conflictingFilters: [],
  options: [
    { key: 'meta_rating', label: 'Default' },
    { key: 'createdAt', labelTranslationKey: 'SortBy.newest' },
    { key: '-createdAt', labelTranslationKey: 'SortBy.oldest' },
    { key: '-price', labelTranslationKey: 'SortBy.lowestPrice' },
    { key: 'price', labelTranslationKey: 'SortBy.highestPrice' },
    {
      key: 'relevance',
      labelTranslationKey: 'SortBy.relevance',
      labelTranslationKeyLong: 'SortBy.relevanceLong',
    },
  ],
};
